import React, { useState } from 'react';
import { Outlet, NavLink, Navigate } from 'react-router-dom';
import { MenuIcon, XIcon, HomeIcon, BarChart3Icon, UsersIcon, ShieldIcon, FileTextIcon, UserIcon, LogOutIcon } from 'lucide-react';
import Header from '../components/Header';
import MobileNav from '../components/MobileNav';
import { useAuth } from '../contexts/AuthContext';
const MainLayout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    user,
    logout
  } = useAuth();
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  // Define navigation items based on user role
  const getNavigationItems = () => {
    const commonItems = [{
      to: '/dashboard',
      label: 'Home',
      icon: <HomeIcon className="w-5 h-5 mr-3" data-id="element-132" />,
      roles: ['msme', 'investor', 'shariah', 'trustee', 'digital-advisor']
    }];
    const roleSpecificItems = [{
      to: '/dashboard/msme',
      label: 'MSME Dashboard',
      icon: <BarChart3Icon className="w-5 h-5 mr-3" data-id="element-133" />,
      roles: ['msme']
    }, {
      to: '/dashboard/msme-applications',
      label: 'My Applications',
      icon: <FileTextIcon className="w-5 h-5 mr-3" data-id="element-134" />,
      roles: ['msme']
    }, {
      to: '/dashboard/rating-agency',
      label: 'Rating Dashboard',
      icon: <BarChart3Icon className="w-5 h-5 mr-3" data-id="element-135" />,
      roles: ['rating-agency']
    }, {
      to: '/dashboard/investor',
      label: 'Investor Portal',
      icon: <UsersIcon className="w-5 h-5 mr-3" data-id="element-136" />,
      roles: ['investor']
    }, {
      to: '/dashboard/shariah',
      label: 'Shariah Compliance',
      icon: <ShieldIcon className="w-5 h-5 mr-3" data-id="element-137" />,
      roles: ['shariah']
    }, {
      to: '/dashboard/trustee',
      label: 'Trustee Management',
      icon: <FileTextIcon className="w-5 h-5 mr-3" data-id="element-138" />,
      roles: ['trustee']
    }, {
      to: '/dashboard/digital-advisor',
      label: 'Digital Advisor Portal',
      icon: <BarChart3Icon className="w-5 h-5 mr-3" data-id="element-139" />,
      roles: ['digital-advisor']
    }];
    // If user is not logged in, show all navigation items
    if (!user) {
      return [...commonItems, ...roleSpecificItems];
    }
    // If user is logged in, filter items based on their role
    return [...commonItems, ...roleSpecificItems.filter(item => item.roles.includes(user.role))];
  };
  const navigationItems = getNavigationItems();
  return <div className="flex flex-col min-h-screen bg-neutral-50" data-id="element-140">
      <Header toggleMobileMenu={toggleMobileMenu} data-id="element-141" />
      <div className="flex flex-1" data-id="element-142">
        {/* Sidebar Navigation (desktop) */}
        <aside className="hidden md:block w-64 bg-white border-r border-neutral-100 p-4" data-id="element-143">
          <nav className="space-y-1" data-id="element-144">
            {navigationItems.map(item => <NavLink key={item.to} to={item.to} className={({
            isActive
          }) => `flex items-center p-3 rounded-lg hover:bg-neutral-50 ${isActive ? 'bg-neutral-50 text-primary font-medium' : 'text-neutral-400'}`} data-id="element-145">
                {item.icon}
                <span data-id="element-146">{item.label}</span>
              </NavLink>)}
            {user && <button onClick={logout} className="flex items-center p-3 rounded-lg hover:bg-neutral-50 text-neutral-400 w-full text-left" data-id="element-147">
                <LogOutIcon className="w-5 h-5 mr-3" data-id="element-148" />
                <span data-id="element-149">Sign Out</span>
              </button>}
          </nav>
          {user && <div className="mt-8 pt-6 border-t border-neutral-100" data-id="element-150">
              <div className="flex items-center p-3" data-id="element-151">
                <div className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center mr-3" data-id="element-152">
                  <UserIcon className="w-5 h-5 text-white" data-id="element-153" />
                </div>
                <div data-id="element-154">
                  <div className="text-sm font-medium" data-id="element-155">{user.name}</div>
                  <div className="text-xs text-neutral-400" data-id="element-156">
                    {user.organization}
                  </div>
                </div>
              </div>
            </div>}
        </aside>
        {/* Main Content */}
        <main className="flex-1 p-4 md:p-6" data-id="element-157">
          <Outlet data-id="element-158" />
        </main>
      </div>
      {/* Mobile Navigation */}
      <MobileNav isOpen={mobileMenuOpen} toggleMenu={toggleMobileMenu} navigationItems={navigationItems} data-id="element-159" />
    </div>;
};
export default MainLayout;